import { render, staticRenderFns } from "./ReclamationCreatePage.vue?vue&type=template&id=4660bf37&"
import script from "./ReclamationCreatePage.vue?vue&type=script&lang=js&"
export * from "./ReclamationCreatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports